import { render } from "./heaxgonStar.vue?vue&type=template&id=277e56e7"
import script from "./heaxgonStar.vue?vue&type=script&lang=js"
export * from "./heaxgonStar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__